import {
  CircularProgress as ChakraCircularProgress,
  forwardRef,
} from '@chakra-ui/react-v2';
import type { CircularProgressProps as ChakraCircularProgressProps } from '@chakra-ui/react-v2';

export type CircularProgressProps = ChakraCircularProgressProps;

export const CircularProgress = forwardRef<ChakraCircularProgressProps, 'div'>(
  (
    {
      trackColor = 'page.plateLight',
      color = 'brand.secondary',
      fontFamily = 'default',
      fontWeight = 'default',
      children,
      ...restProps
    },
    ref,
  ) => {
    return (
      <ChakraCircularProgress
        ref={ref}
        trackColor={trackColor}
        color={color}
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        {...restProps}
      >
        {children}
      </ChakraCircularProgress>
    );
  },
);

CircularProgress.displayName = 'CircularProgress';
